export enum Sticker {
  UNKNOWN,
  ABBOOD_SWIMMING,
  ALI_BASED,
  ALI_LEMON,
  BIDI_AMOOT,
  BISHR_7ATA,
  BISHR_DAPPER,
  BISHR_HAJJ,
  BISHR_MARIO,
  BISHR_ORIGINAL,
  CHOOSE_LOVE,
  CONSULTANT_LIFE,
  HAMARNEH_BURGER,
  I_MISS_THE_OLD_BAKES,
  LAITH_ASCII,
  LAITH_PARTY,
  LOVE,
  PAINTING,
  SEIF_MUSTACHE,
  SEND_A_STICKER,
  SMEIRAT_ARSENAL,
  TAQ_EGG,
  TAQ_I_LOVE_YOU,
  TARAWNEH_BOTTLE,
  TARAWNEH_TONGUE,
  THUMBS_UP,
}

interface StickerData {
  path: string;
  keywords: string[];
  unlockedBy?: Sticker[];
}

const STICKER_MAP: Record<Sticker, StickerData> = {
  [Sticker.UNKNOWN]: { path: "", keywords: [] },
  [Sticker.ABBOOD_SWIMMING]: {
    path: "/stickers/abbood-swimming.gif",
    keywords: ["swim", "pool", "water", "abbood"],
  },
  [Sticker.ALI_BASED]: {
    path: "/stickers/ali_based.png",
    keywords: ["based", "chad", "ali based"],
  },
  [Sticker.ALI_LEMON]: {
    path: "/stickers/ali_lemon.png",
    keywords: ["lemon", "sour"],
  },
  [Sticker.BIDI_AMOOT]: {
    path: "/stickers/bidi_amoot.png",
    keywords: ["die", "bidi", "dead"],
  },
  [Sticker.BISHR_7ATA]: {
    path: "/stickers/bishr_7ata.png",
    keywords: ["7ata", "chad", "based"],
  },
  [Sticker.BISHR_DAPPER]: {
    path: "/stickers/bishr_dapper.png",
    keywords: ["dapper", "smile", "fancy"],
  },
  [Sticker.BISHR_HAJJ]: {
    path: "/stickers/bishr_hajj.png",
    keywords: ["hajj", "mecca"],
  },
  [Sticker.BISHR_MARIO]: {
    path: "/stickers/bishr_mario.png",
    keywords: ["mario", "game", "japan"],
  },
  [Sticker.BISHR_ORIGINAL]: {
    path: "/stickers/bishr_original.png",
    keywords: ["bishr", "bishr baker"],
    unlockedBy: [Sticker.THUMBS_UP],
  },
  [Sticker.CHOOSE_LOVE]: {
    path: "/stickers/choose_love.gif",
    keywords: ["love", "choose", "heart"],
  },
  [Sticker.CONSULTANT_LIFE]: {
    path: "/stickers/consultant_life.png",
    keywords: ["work", "consultant", "grind", "busy"],
  },
  [Sticker.HAMARNEH_BURGER]: {
    path: "/stickers/hamarneh_burger.png",
    keywords: ["burger", "food", "hungry", "eat"],
  },
  [Sticker.I_MISS_THE_OLD_BAKES]: {
    path: "/stickers/i_miss_the_old_bakes.png",
    keywords: ["i miss the old bakes", "old bakes"],
  },
  [Sticker.LAITH_ASCII]: {
    path: "/stickers/laith_ascii.png",
    keywords: ["ascii"],
  },
  [Sticker.LAITH_PARTY]: {
    path: "/stickers/laith_party.png",
    keywords: ["party", "celebrate", "fun"],
    unlockedBy: [Sticker.CHOOSE_LOVE],
  },
  [Sticker.LOVE]: {
    path: "/stickers/love.gif",
    keywords: ["love", "heart", "affection"],
  },
  [Sticker.PAINTING]: {
    path: "/stickers/painting.png",
    keywords: ["time to die"],
  },
  [Sticker.SEIF_MUSTACHE]: {
    path: "/stickers/seif_mustache.png",
    keywords: ["seif", "mustache", "fancy"],
  },
  [Sticker.SEND_A_STICKER]: {
    path: "/stickers/send_a_sticker.png",
    keywords: ["sticker", "send"],
  },
  [Sticker.SMEIRAT_ARSENAL]: {
    path: "/stickers/smeirat_arsenal.png",
    keywords: ["arsenal", "football", "soccer", "smeirat"],
  },
  [Sticker.TAQ_EGG]: {
    path: "/stickers/taq_egg.png",
    keywords: ["egg", "food"],
  },
  [Sticker.TAQ_I_LOVE_YOU]: {
    path: "/stickers/taq_i_love_you.png",
    keywords: ["taq", "طق"],
  },
  [Sticker.TARAWNEH_BOTTLE]: {
    path: "/stickers/tarawneh_bottle.png",
    keywords: ["bottle", "drink", "tarawneh"],
  },
  [Sticker.TARAWNEH_TONGUE]: {
    path: "/stickers/tarawneh_tongue.png",
    keywords: ["tongue", "silly"],
  },
  [Sticker.THUMBS_UP]: {
    path: "/stickers/thumbs_up.gif",
    keywords: ["ok", "yes", "thumbs", "agree", "good", "hello", "hi"],
  },
};

export function getSticker(sticker: Sticker): StickerData {
  return STICKER_MAP[sticker];
}

export function resolveSticker(input: string | Sticker): Sticker[] {
  if (typeof input === "number") {
    const stickerReuslt = Object.entries(STICKER_MAP)
      .filter(([, data]) => data.unlockedBy?.includes(input))
      .map(([key]) => Number(key) as Sticker);
    return stickerReuslt.length > 0 ? stickerReuslt : [Sticker.SEND_A_STICKER];
  }

  const lower = input.toLowerCase();
  const result = Object.entries(STICKER_MAP)
    .filter(([, data]) => data.keywords.some((kw) => lower.includes(kw)))
    .map(([key]) => Number(key) as Sticker);
  return result.length > 0 ? result : [Sticker.PAINTING];
}
